var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 726.2965879265092 726.2965879265092",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l726.2966 0l0 726.2966l-726.2966 0l0 -726.2966z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l726.2966 0l0 726.2966l-726.2966 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m95.685036 53.902885l534.92914 0l0 618.48816l-534.92914 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m95.685036 53.902885l534.92914 0l0 618.48816l-534.92914 0z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.8665ba709eefcdcc06be636647e3d740.svg";
export { ForwardRef as ReactComponent };